import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDDisplayDateStr } from '../Displayers/TEDDisplayDateStr';
import { TEDParseDateStr } from '../Parsers/TEDParseDateStr';

class TEDFormatDateStr implements IFormatter {
  displayer = TEDDisplayDateStr.getInstance();
  parser = TEDParseDateStr.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatDateStr };
